import type { B2cStageRow } from "@/infrastructure/supabase/b2c-board.types";

/**
 * A stage is current when today falls inside its window (both ends inclusive). Dates are
 * ISO `YYYY-MM-DD`, so a string compare is a date compare. A stage with no window is never
 * current: the board then shows it collapsed until someone opens it.
 */
export function isCurrentStage(
  stage: Pick<B2cStageRow, "start_date" | "end_date">,
  today: string
): boolean {
  if (!stage.start_date || !stage.end_date) return false;
  return stage.start_date <= today && today <= stage.end_date;
}
